import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as USER INITIATED, so the error interceptor surfaces a permission denial (403) to
 * the user even for GET requests.
 *
 * Background GET requests are deliberately silent on a 403: pages such as the dashboard fire many
 * widget loads at once and those components render their own inline "no permission" state, so
 * toasting each denial would be redundant and noisy. A GET that the user explicitly triggered (an
 * export, a file download, opening a record) has no such inline state, and failing silently leaves
 * the user with no feedback at all.
 *
 * Requests made with ApiRequestService.makeDownloadRequest() set this automatically, since a
 * download is always user initiated. For other GETs, opt in via the
 * `surfacePermissionErrors` argument on makeRequest()/makeRequestObservable().
 */
export const SURFACE_PERMISSION_ERRORS = new HttpContextToken<boolean>(() => false);
